import React, { useCallback, useEffect, useState } from 'react';
import { Grid, Button, Box, Stack } from '@mui/material';
import { Breadcrumbs} from '../../../../Components';
import { useDispatch, useSelector } from 'react-redux';
import { AddItem, fetchDepartments, TableActions } from '../index';
import { setRightDrawer } from '../../../Common/App';
import { DepartmentList } from './Cards/DepartmentList';

export const Department = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const filters = useSelector((store) => store.departments?.config?.filters);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        const columns = ['id', 'department_name', 'manager_id', 'is_parking', 'icon'];
        await fetchDepartments({dispatch, filters:{...filters, paginate:false, with:['manager'], withCount:['users'], columns}}).then((res)=>{
            setIsLoading(false);
        });
    },[filters, dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const addItem = () => {
        dispatch(setRightDrawer({ component: <AddItem />, open: true }));
    };

    return (
        <Grid container spacing={2}>
            {/* Header */}
            <Grid item xs={12}>
                <Box justifyContent="space-between" display="flex">
                    <Breadcrumbs items={['DASHBOARD', 'DEPARTMENTS']} />

                    <Stack direction="row" spacing={2}> 
                        <TableActions />
                        <Button variant="contained" onClick={addItem}>
                            Add Department
                        </Button>
                    </Stack>
                </Box>
            </Grid>

            {/* Department List */}
            <Grid item xs={12} sx={{mt:2}}>
                <DepartmentList isLoading={isLoading} setIsLoading={setIsLoading} />
            </Grid>
        </Grid>
    );
};
